import React from "react";
import { ThemeProvider } from "../contexts/themeContext";
import { useDarkModeAvailability } from "../hooks/useDarkModeAvailability";

/** The theme provider, gated by the `dark-mode` flag. Mount inside LaunchDarkly. */
export const ThemedApp = ({ children }: { children: React.ReactNode }) => (
  <ThemeProvider availability={useDarkModeAvailability()}>
    {children}
  </ThemeProvider>
);
